import React from 'react';
import Heading from '../../components/Heading';
import WithNavigation from '../../layouts/WithNavigation';
import ReportingForm from './ReportingForm.tsx';
import './Reporting.scss';
import { LLMContainer } from 'src/components/LLM/LLMContainer';

const Reporting = () => {
  return (
    <WithNavigation
      title="Reporting"
      top={<Heading headline="Reporting" />}
      bottom={
        <div className="reporting">
          <ReportingForm />
        </div>

      }
    />
  );
};

export default Reporting;
